import HubEpworthQuizIntroModule from './HubEpworthQuizIntroModule'

export default HubEpworthQuizIntroModule
